<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen ">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45 mb-0">
            CÉSAR VALLEJO: <br>
        </p>
        <p class="fontMS500 colorPrincipal font-24">“Y SI DESPUÉS DE TANTAS PALABRAS,<br>
            NO SOBREVIVE LA PALABRA”</p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio38/cesar-vallejo">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio38/cesar-vallejo">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio38/cesar-vallejo">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" src="/assets/images/micrositio/micrositio38/CESAR-001.png">
</section>

<div class="fondoBlanco_Intro mt-1">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-center font-24">
                    <br><br>
                    EN LA DÉCADA DE 1920, EN EL ÁMBITO LITERARIO PERUANO SE DESARROLLARON NUEVAS FORMAS DE EXPRESIÓN. EL
                    VANGUARDISMO SE POSICIONÓ EN EL ESCENARIO CULTURAL E IMPULSÓ A LOS CREADORES A DESAFIAR LAS
                    CONVENCIONES DE LA ESCRITURA TRADICIONAL DECIMONÓNICA DESDE UNA PERSPECTIVA ARTÍSTICA.
                    <br><br>
                    <span class="fontMS300"> 
                        EL VANGUARDISMO PERUANO SE CARACTERIZÓ POR INNOVAR LOS CONTENIDOS Y LOS ASPECTOS FORMALES DE LA
                        LITERATURA. ESTO SE MANIFESTÓ EN EL USO DE UNA MÉTRICA LIBRE, LA EXPLORACIÓN DE LA PÁGINA EN BLANCO, LA
                        TRANSGRESIÓN DE NORMAS GRAMATICALES Y DE LAS REGLAS DE PUNTUACIÓN.
                        <br><br>
                        POR ESOS AÑOS, CÉSAR VALLEJO MENDOZA (1892-1938), QUE YA HABÍA PUBLICADO LOS HERALDOS NEGROS (1918),
                        RENUEVA LA LITERATURA PERUANA CON TRILCE (1922), OBRA PIONERA DE LA VANGUARDIA LATINOAMERICANA Y
                        MUNDIAL. VALLEJO CREÓ UN LENGUAJE PROPIO, SINGULAR Y CONMOVEDOR, QUE ALCANZA COTAS DE BELLEZA
                        INUSITADAS QUE TRASCIENDEN EL ÁMBITO DE LA POESÍA Y NARRATIVA HISPANA. SU TRABAJO ES, ASÍ, UN HITO EN LA
                        HISTORIA LITERARIA, POR LO QUE ES CONSIDERADO UNO DE LOS MÁS GRANDES EXPONENTES DEL VANGUARDISMO
                        LITERARIO EN EL PERÚ Y EL MUNDO.
                    </span>
                    <br>
                </p>
                <div class="row p-5">
                    <div class="col-sm-3">
                        <br>
                    </div>
                    <div class="col-sm-6">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-002.png">
                    </div>
                    <div class="col-sm-3">
                        <br>
                    </div>
                </div>
                <p class="fontMS500 text-center font-24">
                    POR LO SEÑALADO, Y, SOBRE TODO, POR EL HECHO DE QUE PARTE IMPORTANTE DE LA OBRA DE CÉSAR VALLEJO HA SIDO
                    DECLARADA, EN LOS ÚLTIMOS AÑOS, COMO PATRIMONIO CULTURAL DE LA NACIÓN, SE OFRECE ESTE MICROSITIO QUE
                    ABARCA LOS DIVERSOS GÉNEROS LITERARIOS PRACTICADOS POR EL AUTOR DE ESPAÑA, APARTA DE MÍ ESTE CÁLIZ, LOS
                    CUALES REQUIEREN SU DIFUSIÓN Y, ESENCIALMENTE, SU (RE)CONOCIMIENTO.
                    <br><br>
                    <span class="fontMS300">
                    COMO SEÑALÓ EL DESTACADO CRÍTICO JOSÉ MIGUEL OVIEDO, «¿QUÉ ES LO QUE ESTAMOS CONMEMORANDO EN VALLEJO?
                    SIN DUDA, LA PROFUNDA IDENTIDAD DE UNA OBRA PRODIGIOSA CON EL RIGOR MORAL DEL HOMBRE QUE LA CREÓ. RÍOS
                    DE PALABRAS CORREN Y CORRERÁN SOBRE LA PERSONA Y LA POESÍA DE VALLEJO, PERO NUNCA SE HABRÁ INSISTIDO
                    BASTANTE EN LA ENCARNACIÓN TOTAL DEL DESTINO Y LA FE DE ESE HOMBRE EN SU PALABRA, LOS LÍMITES DE SU VIDA
                    CONSTITUYEN LA NORMA INTERIOR DE SU POESÍA, SE EXPRESAN DESGARRADORAMENTE A TRAVÉS DE ELLA Y EXPLICAN SU
                    ARDIENTE TEXTURA VERBAL».</span>
                </p>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3 bott">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio38/CESAR-LINEA-001.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio38/CESAR-LINEA-001.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            POESÍA
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio38/CESAR-LINEA-001.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio38/CESAR-LINEA-001.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 mx-3 md-3">
                        <p class="fontMS100 text-center text-white font-22">
                            <br><br>
                            LA VALÍA DE LA POESÍA DE CÉSAR VALLEJO SE PUEDE RESUMIR EN ESTAS PALABRAS DE J. M. COHEN QUIEN, EN SU
                            ARTÍCULO «CÉSAR VALLEJO: POETA GENIAL DE ESTE SIGLO», NOS DICE LO SIGUIENTE:
                            <br><br>
                            <span class="fontMS500">
                            «PARA MÍ ES VALLEJO UNO DE LOS POCOS POETAS GENIALES DEL SIGLO. NADIE LO IGUALA SINO YEATS, ELIOT,
                            MAYAKOVSKY, PASTERNAK, RILKE, MACHADO Y UN PAR DE OTROS. ES EL PRIMER POETA DE HISPANOAMÉRICA. (…)
                            ESCRIBE DEL HOMBRE COMO ANIMAL DESNUDO PERSEGUIDO POR SU DESTINO, SUFRIENDO Y LUCHANDO HASTA
                            SU ÚLTIMO MOMENTO. ES LA POESÍA DE UN HOMBRE QUE HABLA DIRECTAMENTE, SIN ESA RETÓRICA
                            DESBORDANTE, QUE ES LA ENFERMEDAD FATAL DE MUCHOS CONTEMPORÁNEOS SUYOS DE HABLA ESPAÑOLA».</span>
                            <br><br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/11595" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-003.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Los heraldos negros: poemas / César
                            A. Vallejo. – Lima: [s. n. ], 1918. – 153
                            p. ; 19 cm.<br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/11595" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/11604" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-004.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Trilce / César a. Vallejo. – Lima: Talleres
                            Tipográficos de la Penitenciaría, 1922. – xvi,
                            121 p. ; 19 cm.<br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/11604" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/10725" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-005.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Poemas humanos (1923-1938) / César
                            Vallejo. – 1a ed. – Paris: Les Éditions des
                            Presses Modernes, 1939. – 158 p. : retr. ;
                            23 cm.<br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/10725" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/80561" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-006.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            España, aparta de mí este cáliz : poemas /
                            César Vallejo<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/80561" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br><br>
                        </p>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/58627" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-007.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000 ; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Te vas / César Vallejo. – [Lima, 1914]. 3
                            p. ; 16.4 x 11.5 cm<br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/58627" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/57777" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-008.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            [Requisitoria del individuo : poema XVI
                            de Trilce] / César Vallejo. – París,
                            diciembre 1930. 1 h. ; 17.3 x 11.5 cm.<br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/57777" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81104" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-009.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-11" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Sombras / César A. Vallejo. – Balnearios:
                            publicación semanal de Chorrillos,
                            Barranco y Miraflores. Año VII, no. 320 (22
                            jul. 1917). Pág. 4.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81104" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81111" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-010.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Noche en el campo / César A. Vallejo. 
                            La Reforma: diario político, 
                            comercial e informativo. 
                            Trujillo (20 may. 1916). Pág. 4.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81111" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-6">
                        <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-LINEA-002.png">
                    </div>
                    <div class="col-sm-6"></div>
                </div>

                <div class="row">
                    <div class="col-sm-6">
                        <br><br>
                        <div class="row" style="color: #465a65">
                            <div class="col-sm-2" style="width: 10%">
                                <img src="/assets/images/micrositio/micrositio38/CESAR-ICONO-001.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 text-white font-14" style="word-wrap: break-word">
                                    [Trilce II] / César A. Vallejo. – Bohemia: arte, letras, frivolidades.<br>
                                    Año I, no. 1 (15 jun. 1921). Pág. 5.
                                    <br><br>
                                    <span class="fontMS100">
                                    Disponible en:
                                    <a href="http://hdl.handle.net/20.500.14428/81105" target="_blank" style="color: #ffffff;">http://hdl.handle.net/20.500.14428/81105</a>
                                    <br><br>
                                    </span>
                                </p>
                            </div>
                            <div class="col-sm-2" style="width: 10%">
                                <img src="/assets/images/micrositio/micrositio38/CESAR-ICONO-001.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 text-white font-14" style="word-wrap: break-word;">
                                    [Primeras versiones de los poemas XII, XXXII y XLIV de Trilce] /
                                    César A. Vallejo. – La Crónica: diario ilustrado, político,
                                    independiente e informativo (20 jun. 1921). Pág. 7.
                                    Título: «Versos de Vallejo».<br>
                                    Epígrafe de la sección: «Páginas literarias».
                                    <br><br>
                                    <span class="fontMS100">
                                    Disponible en:
                                    <a href="http://hdl.handle.net/20.500.14428/81110" target="_blank" style="color: #ffffff;">http://hdl.handle.net/20.500.14428/81110</a>
                                    <br><br>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <br><br>
                        <div class="row" style="color: #465a65">
                            <div class="col-sm-2" style="width: 10%">
                                <img src="/assets/images/micrositio/micrositio38/CESAR-ICONO-001.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 text-white font-14" style="word-wrap: break-word;">
                                    Lomo de las sagradas escrituras. Actitud de excelencia / César
                                    Vallejo. Mundial: revista semanal ilustrada. Año VIII, no. 388 (18
                                    nov. 1927)<span class="fontMS100"> , p. 58 ; 34 x 23.5 cm. Pág. 31.</span><br>
                                    Poemas forman parte del artículo «Nuevos versos de César
                                    Vallejo». Poemas publicados en: Poemas humanos.
                                    <br><br>
                                    <span class="fontMS100">
                                    Disponible en:
                                    <a href="http://hdl.handle.net/20.500.14428/81117" target="_blank" style="color: #ffffff;">http://hdl.handle.net/20.500.14428/81117</a>
                                    <br><br>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio38/CESAR-LINEA-001.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 200%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            NARRATIVA<br>

                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio38/CESAR-LINEA-001.png">
                    </div>
                </div>
                <div class="col-sm-1"></div>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio38/CESAR-LINEA-001.png">
                </div>
                <p class="text-center  fontMS500 font-24">
                    <br><br>
                    SEGÚN RICARDO GONZÁLEZ VIGIL, LA NARRATIVA DE CÉSAR VALLEJO «COMPRENDE TENDENCIAS Y ETAPAS
                    DIVERSAS: LA SUPERACIÓN DE LA NARRATIVA MODERNISTA (ESCALAS Y FABLA SALVAJE) Y LA EXPLORACIÓN
                    VANGUARDISTA DE LA PROSA NARRATIVA, (…) (NUEVAMENTE ESCALAS, ADEMÁS DE ALGUNOS TEXTOS DE
                    CONTRA EL SECRETO PROFESIONAL); TAMBIÉN EL CULTIVO DE UN REALISMO PRÓXIMO, AUNQUE SOLO EN
                    PARTE, AL “REALISMO CRÍTICO” DE GORKI Y AL “REALISMO SOCIALISTA” DE LA LITERATURA SOVIÉTICA (EL
                    TUNGSTENO, NOVELA CON NEXOS INTERESANTES CON LA CORRIENTE INDIGENISTA; Y PACO YUNQUE)».
                    <br>
                </p>
                <div class="row p-5">
                    <div class="col-sm-3">
                        <br>
                    </div>
                    <div class="col-sm-6">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-011.png">
                    </div>
                    <div class="col-sm-3">
                        <br>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/12647" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-012.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Escalas / César A. Vallejo. – Lima :
                            Talleres Tipográficos de la Penitenciaría,
                            1923. – 131 p. ; 20 cm.<br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/12647" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/80562" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-013.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Fabla salvaje / César Vallejo. – Lima:
                            Impr. Lux, 1923. – 50 p. ; 16 cm.
                            Prólogo de Pedro Barrantes Castro.
                            Colección La Novela Peruana, año I, no. 9.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/80562" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/57987" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-014.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Hacia el reino de los sciris [manuscrito] /
                            César Vallejo. – París, 1924-1928. 27 f. + 1
                            carátula ; 28 x 21.5 cm.<br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/57987" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>

                <div class="row mt-5">
                    
                    <div class="col-sm-1"></div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/11192" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-015.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            El tungsteno : novela / César Vallejo. –
                            Madrid: Edit. Cenit, 1931. – 205 p. ; 20 cm.<br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/11192" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81103" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-016.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Paco Yunque : cuento inédito para
                            niños / César Vallejo. Apuntes del
                            hombre. Año I, no. 1 (jul. 1951), Pág. 1.
                            <br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81103" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/80563" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-017.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Sabiduría: capítulo de una novela inédita /
                            por César Vallejo. – Amauta : doctrina,
                            arte, literatura, polémica. Pág. 19.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/80563" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio38/CESAR-LINEA-003.png" width="90%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100 font-18">
                            <br>
                            <span>
                                <br><br>
                                «RESULTA IRREFUTABLE QUE LA NARRATIVA (CUENTOS, ESTAMPAS, MICRORRELATOS Y NOVELAS) DE CÉSAR VALLEJO NO
                                POSEE LOS ALTÍSIMOS MÉRITOS DE SU OBRA POÉTICA. PERO EXISTEN BUENAS RAZONES PARA DIFUNDIRLA Y ESTUDIARLA
                                CON MÁS AHÍNCO QUE EL DESPLEGADO HASTA AHORA, TAREA QUE HA COMENZADO A SER ASUMIDA CON EL RELIEVE QUE
                                MERECE DESDE EL LIBRO DE EDUARDO NEALE-SILVA [CÉSAR VALLEJO, CUENTISTA. ESCRUTINIO DE UN MÚLTIPLE INTENTO DE
                                INNOVACIÓN], SOBRESALIENDO LOS ESTUDIOS DE ANTONIO GONZÁLEZ MONTES, JUAN CARLOS GALDO Y LUIS REBAZA».<br><br>
                                («PRÓLOGO» DE LA NARRATIVA COMPLETA, DE CÉSAR VALLEJO. RICARDO GONZÁLEZ VIGIL. 2013)   
                                <br><br>
                            </span>
                        </p>

                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio38/CESAR-LINEA-004.png" class="reflejo"
                    width="90%" style="margin-left: 10%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio38/CESAR-LINEA-001.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 140%;margin-bottom: 5%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            TEATRO<br>

                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio38/CESAR-LINEA-001.png">
                    </div>
                </div>
                <div class="col-sm-1"></div>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio38/CESAR-LINEA-001.png">
                </div>
                <p class="text-justify fontMS500 font-24">
                    <br><br>
                    LA PRODUCCIÓN TEATRAL DE VALLEJO ES EL GÉNERO QUE REQUIERE DE UNA MAYOR REVISIÓN CRÍTICA. SE
                    TRATA DE UN CONJUNTO DE OBRAS QUE, PESE A SU CANTIDAD (CUATRO PIEZAS LARGAS Y UN
                    SIGNIFICATIVO NÚMERO DE PIEZAS MENORES Y FRAGMENTARIAS), NO HA SIDO ESTUDIADO A
                    PROFUNDIDAD Y HA RESULTADO HISTÓRICAMENTE CUESTIONADO POR TRATARSE DE UN TEATRO
                    MAYORMENTE SITUADO DENTRO DE LOS PARÁMETROS DEL TEATRO POLÍTICO Y SOVIÉTICO DEL MOMENTO.
                    COMO SEÑALA LA CRÍTICA, «EN TODAS SUS OBRAS TEATRALES EXISTE EL INTENTO DE CRITICAR UN
                    DETERMINADO PROBLEMA O CONFLICTO DE TIPO SOCIAL Y LA NECESIDAD DE CREAR UN MODELO DE
                    PRODUCCIÓN CULTURAL DISTINTO DEL IMPERANTE».

                    <br><br><br>
                </p>

                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/57989" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-020.png">
                        </a>
                        
                        <p class="text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Les taupes : cinq scènes et un épilogue /
                            César Vallejo. -- [París, 1928-1930]. – 16 f.
                            + 1 carátula ; 28 x 21.5 cm.<br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/57989" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/57797" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-018.png">
                        </a>
                        
                        <p class="text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            La mort : tragédie en un acte = La
                            muerte : tragedia en un acto / César
                            Vallejo. -- [París, 1930]. – 19 f. + 1
                            carátula ; 27.8 x 21.5 cm.<br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/57797" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81112" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-019.png">
                        </a>
                        
                        <p class="text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Una tragedia inédita de Vallejo [Moscú
                            contra Moscú] / [César Vallejo]. Letras
                            Peruanas: revista de humanidades.
                            Año II, no. 6 (abr.-jun. 1952). Pág. 1.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81112" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>

                <div class="row mt-5">
                    
                    <div class="col-sm-3"></div>
                    <div class="col mx-2 md-2">
                        <a href="https://hdl.handle.net/20.500.14428/57993" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-021.png">
                        </a>
                        
                        <p class="text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Le songe d´une nuit de printemps : à
                            Paris vers 1935-1936 / César Vallejo. –
                            [Paris, 1935-1936].<br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/57993" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-2 md-2">
                        <a href="https://hdl.handle.net/20.500.14428/57997" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-022.png">
                        </a>
                        
                        <p class="text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Dressing-room : bufonada en un
                            prólogo y cuatro actos / César
                            Vallejo. – París, 1932-1937. 6 f. + 1
                            carátula : 28 x 21.5 cm.<br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/57997" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-3"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio38/CESAR-LINEA-003.png" width="90%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100 font-18">
                            <br>
                            <span>
                                <br><br>
                                «ESCRITAS ORIGINALMENTE EN FRANCÉS, VALLEJO NO PUBLICÓ NI ESTRENÓ EN VIDA ESTAS OBRAS, LAS QUE TAMPOCO HAN
                                SIDO REPRESENTADAS HASTA EL MOMENTO, QUIZÁ DEBIDO A QUE SU CONCEPCIÓN SUPONE GRANDIOSAS AMBICIONES
                                QUE SUPERAN LARGAMENTE LAS POSIBILIDADES DE LA ESCENIFICACIÓN COMÚN. SIN EMBARGO, ESTO NO RESTA MÉRITO A
                                SU PRODUCCIÓN DRAMÁTICA. VALLEJO IMPREGNÓ A ESTAS OBRAS, COMO AL RESTO DE SU ESCRITURA, UN VIGOROSO
                                ALIENTO DE VANGUARDIA, PUES ESTABA CONVENCIDO DE QUE EL TEATRO ERA CAPAZ DE SINTETIZAR TODAS LAS ARTES. NO
                                DEBE ENTONCES EXTRAÑARNOS LA ENERGÍA QUE DESPLEGÓ PARA ACOMETER LA CREACIÓN DE ESTOS TRABAJOS. COMO EN
                                SU NARRATIVA Y EN SU POESÍA, VALLEJO NO QUIERE RETRATAR LA VIDA Y CUMPLIR UNA UTOPÍA EN LA QUE ÉTICA Y ESTÉTICA
                                RESULTAN SIENDO UNA Y LA MISMA».<br><br>
                                («PRESENTACIÓN». SALOMÓN LERNER FEBRES. 1999).   
                                <br><br>
                            </span>
                        </p>

                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio38/CESAR-LINEA-004.png" class="reflejo"
                    width="90%" style="margin-left: 10%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio38/CESAR-LINEA-001.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 150%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            ARTÍCULOS Y CRÓNICAS<br>

                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio38/CESAR-LINEA-001.png">
                    </div>
                </div>
                <div class="col-sm-1"></div>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio38/CESAR-LINEA-001.png">
                </div>
                <p class="text-center fontMS500 font-24">
                    <br><br>
                    LA ACTIVIDAD PERIODÍSTICA DE VALLEJO SE EFECTUÓ PRINCIPALMENTE EN EUROPA Y FUE DIFUNDIDA EN LOS DIARIOS EL
                    NORTE DE TRUJILLO (1923-1930) Y EL COMERCIO (1929-1930), Y EN LAS REVISTAS MUNDIAL (1925-30) Y VARIEDADES
                    (1926-30) ASÍ COMO EN DIVERSOS MEDIOS DE AMÉRICA Y EUROPA.
                    <br><br>
                    EN SU PRODUCCIÓN PERIODÍSTICA SE PUEDEN APRECIAR DOS ETAPAS. EN LA PRIMERA DE ELLAS, QUE COMPRENDE SUS
                    COLABORACIONES EN EL NORTE, SE APRECIA LA INFLUENCIA MODERNISTA, CARACTERIZADA POR LA BÚSQUEDA DE LA
                    PALABRA EXQUISITA, LE MOT RARE [«LA PALABRA RARA»].
                    <br><br>
                    MIENTRAS TANTO, EN LA SIGUIENTE ETAPA --QUE ESTÁ REPRESENTADA POR LOS TEXTOS QUE REPRODUCIMOS EN ESTA
                    SECCIÓN--, SE APRECIA SU INTERÉS POR LA BÚSQUEDA DE LE MOT JUSTE [«LA PALABRA JUSTA»] QUE, EN PALABRAS DE
                    JORGE PUCCINELLI, «TIENE EN ÉL, A NUESTRO MODO DE VER, UNA DOBLE VALENCIA: ES NO SOLO LA PALABRA EXACTA Y
                    PRECISA SINO LA PALABRA QUE EXPRESA LA JUSTICIA».
                    <br><br><br>
                </p>

                <div class="row">
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81114" target="_blank">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-023.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Los Grandes Periódicos
                            íbero-americanos / César Vallejo.
                            Mundial : revista semanal ilustrada.
                            Año V, no. 255 (1 may. 1925). Pág. 3.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81114" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81115" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-024.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Una gran lucha entre Francia y Estados
                            Unidos / César Vallejo. Mundial : revista
                            semanal ilustrada. Año VI, no. 304 (9
                            abr. 1926). Pág. 11.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81115" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81116" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-025.png">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            La muerte de Claude Monet / César
                            Vallejo. Mundial : revista semanal
                            ilustrada. Año VII, no. 347 (4 feb.
                            1927). Pág. 13.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81116" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/81118" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-026.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Un atentado contra el Regente Hort[h]y
                            / César Vallejo. – Mundial : revista
                            semana ilustrada. Año VIII, no. 447 (11
                            ene. 1929). Pág. 6.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81118" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col mx-2 md-2">
                        <a href="http://hdl.handle.net/20.500.14428/81120" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-027.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            La vida nocturna en las grandes capitales /
                            César Vallejo. Mundial : revista semanal
                            ilustrada. Año IX, no. 461 (19 abr. 1929).
                            Pág. 6.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81120" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-2 md-2">
                        <a href="http://hdl.handle.net/20.500.14428/81121" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-028.png">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Pacifismo capitalista y pacifismo
                            proletario / César Vallejo. Mundial :
                            revista semanal ilustrada. Año IX, no.
                            481 (6 set. 1929). Pág. 6.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81121" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-2 md-2">
                        <a href="http://hdl.handle.net/20.500.14428/81122" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-029.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            La vida de Lenin / César Vallejo. Mundial :
                            revista semanal ilustrada. Año IX, no. 485
                            (4 oct. 1929). Pág. 9.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81122" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br><br>
                        </p>
                    </div>
                    <div class="col mx-2 md-2">
                        <a href="http://hdl.handle.net/20.500.14428/81123" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-030.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Clemenceau ante la historia / César
                            Vallejo. Mundial : revista semanal
                            ilustrada. Año X, no. 499 (11 ene.
                            1930). Pág. 7.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81123" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-6">
                        <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-LINEA-005.png">
                    </div>
                    <div class="col-sm-6"></div>
                </div>

                <div class="row">
                    <div class="col-sm-6">
                        <br><br>
                        <div class="row" style="color: #465a65">
                            <div class="col-sm-2" style="width: 10%">
                                <img src="/assets/images/micrositio/micrositio38/CESAR-ICONO-002.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-14" style="word-wrap: break-word">
                                    El asesino de Barr[è]s / César Vallejo. Variedades: revista semanal
                                    ilustrada. Año XXII, no. 958 (21 jun. 1926). Pág. 33.
                                    <br><br>
                                    <span class="fontMS300 ">
                                    Disponible en:<br>
                                    <a href="http://hdl.handle.net/20.500.14428/81128" target="_blank" style="color: #000000">http://hdl.handle.net/20.500.14428/81128</a>
                                    <br><br>
                                    </span>
                                </p>
                            </div>
                            <!-- <div class="col-sm-2" style="width: 10%">
                                <img src="/assets/images/micrositio/micrositio38/CESAR-ICONO-002.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-14" style="word-wrap: break-word">
                                    Vanguardia y retaguardia / César Vallejo. Variedades: revista
                                    semanal ilustrada. Año XXIV, no. 1059 (16 jun. 1928), p. [52]-[54] :
                                    il. ; 26 x 15.5 cm.<br>
                                    Antes del título: «Desde París».<br>
                                    «Exclusiva de Variedades».
                                    <br><br>
                                    <span class="fontMS300 ">
                                    Disponible en:<br>
                                    <a href="http://hdl.handle.net/20.500.14428/81127" target="_blank" style="color: #000000">http://hdl.handle.net/20.500.14428/81127</a>
                                    <br><br>
                                    </span>
                                </p>
                            </div> -->
                            <div class="col-sm-2" style="width: 10%">
                                <img src="/assets/images/micrositio/micrositio38/CESAR-ICONO-002.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-14" style="word-wrap: break-word">
                                    La megalomanía de un continente / César Vallejo. El Comercio (3
                                    feb. 1929). Pág. 20.<br>
                                    «De César Vallejo».
                                    <br><br>
                                    <span class="fontMS300 ">
                                    Disponible en:<br>
                                    <a href="http://hdl.handle.net/20.500.14428/81106" target="_blank" style="color: #000000">http://hdl.handle.net/20.500.14428/81106</a>
                                    <br><br>
                                    </span>
                                </p>
                            </div>
                            <div class="col-sm-2" style="width: 10%">
                                <img src="/assets/images/micrositio/micrositio38/CESAR-ICONO-002.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-14" style="word-wrap: break-word">
                                    Cómo será la guerra futura / César Vallejo. El Comercio (15 set.
                                    1929). Pág. 15.<br>
                                    Comentario acerca de los ejercicios aéreos militares en el Bosque
                                    de Vincennes de París.
                                    <br><br>
                                    <span class="fontMS300 ">
                                    Disponible en:<br>
                                    <a href="http://hdl.handle.net/20.500.14428/81107" target="_blank" style="color: #000000">http://hdl.handle.net/20.500.14428/81107</a>
                                    <br><br>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <br><br>
                        <div class="row" style="color: #465a65">
                            <div class="col-sm-2" style="width: 10%">
                                <img src="/assets/images/micrositio/micrositio38/CESAR-ICONO-002.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-14" style="word-wrap: break-word">
                                    El sombrero es el hombre / César Vallejo. Variedades: revista
                                    semanal ilustrada. Año XXII, no. 964 (21 ago. 1926). Pág. 36.
                                    Antes del título: «Crónicas de París».<br>
                                    «Exclusiva de Variedades».<br>
                                    «París, julio de 1926».
                                    <br><br>
                                    <span class="fontMS300">
                                    Disponible en:<br>
                                    <a href="http://hdl.handle.net/20.500.14428/81129" target="_blank" style="color: #000000">http://hdl.handle.net/20.500.14428/81129</a>
                                    <br><br>
                                    </span>
                                </p>
                            </div>
                            <div class="col-sm-2" style="width: 10%">
                                <img src="/assets/images/micrositio/micrositio38/CESAR-ICONO-002.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-14" style="word-wrap: break-word">
                                    Autopsia del suprerealismo [sic] / César Vallejo. Variedades: revista
                                    semanal ilustrada. Año XXVI, no. 1151 (26 mar. 1930). Pág. 13.
                                    Antes del título: «Desde París».<br>
                                    «Especial para Variedades».
                                    <br><br>
                                    <span class="fontMS300">
                                    Disponible en:<br>
                                    <a href="http://hdl.handle.net/20.500.14428/81130" target="_blank" style="color: #000000">http://hdl.handle.net/20.500.14428/81130</a>
                                    <br><br>
                                    </span>
                                </p>
                            </div>
                            <div class="col-sm-2" style="width: 10%">
                                <img src="/assets/images/micrositio/micrositio38/CESAR-ICONO-002.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-14" style="word-wrap: break-word">
                                    Panait Istrati político / César Vallejo. El Comercio (16 mar. 1930).
                                    Pág. 9.<br>
                                    «Para El Comercio».<br>
                                    Comentario sobre la actitud crítica del escritor rumano Panait
                                    Istrati hacia el régimen soviético.
                                    <br><br>
                                    <span class="fontMS300 ">
                                    Disponible en:<br>
                                    <a href="http://hdl.handle.net/20.500.14428/81108" target="_blank" style="color: #000000">http://hdl.handle.net/20.500.14428/81108</a>
                                    <br><br>
                                    </span>
                                </p>
                            </div>
                            <div class="col-sm-2" style="width: 10%">
                                <img src="/assets/images/micrositio/micrositio38/CESAR-ICONO-002.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-14" style="word-wrap: break-word">
                                    El caso teórico y práctico de Francia / César Vallejo. El Comercio.
                                    Supl. Semanal Ilustrado. No. 60 (14 dic. 1930). Pág. 28. Antes del
                                    título: Las grandes crisis económicas del día.<br>
                                    «Para El Comercio».<br>
                                    «París, noviembre de 1930».
                                    <br><br>
                                    <span class="fontMS300 ">
                                    Disponible en:<br>
                                    <a href="http://hdl.handle.net/20.500.14428/81133" target="_blank" style="color: #000000">http://hdl.handle.net/20.500.14428/81133</a>
                                    <br><br>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio38/CESAR-LINEA-003.png" width="90%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100 font-18">
                            <br>
                            <span>
                                <br><br>
                                «ESCRITAS ORIGINALMENTE EN FRANCÉS, VALLEJO NO PUBLICÓ NI ESTRENÓ EN VIDA ESTAS OBRAS, LAS QUE TAMPOCO HAN
                                SIEN EL SUBSTRATO DEL PERIODISMO PARADIGMÁTICO DE VALLEJO, HALLAMOS SU ESENCIA PEDAGÓGICA: PÁGINAS
                                ESCRITAS, DESDE UN PERIÓDICO O REVISTA, DESTINADAS A EDUCAR A LOS LECTORES, INFORMACIÓN COMO FORMACIÓN DE
                                LOS RECEPTORES. CUANDO EL POETA LOS CONDUCE POR LOS VERICUETOS DEL ARTE MODERNO, DE SUS FORTUNAS Y
                                ADVERSIDADES ESTÁ COADYUVANDO A LA TAREA DE DILATAR SU HORIZONTE CULTURAL. PERO AQUÍ, COMO EN OTRAS
                                INSTANCIAS, EL BARDO-PERIODISTA ES CONSCIENTE».<br><br>
                                (CÉSAR VALLEJO: PERIODISTA PARADIGMÁTICO. WINSTON ORRILLO. 1998).   
                                <br><br>
                            </span>
                        </p>

                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio38/CESAR-LINEA-004.png" class="reflejo"
                    width="90%" style="margin-left: 10%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio38/CESAR-LINEA-001.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 150%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            ENSAYOS Y REPORTAJES<br>

                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio38/CESAR-LINEA-001.png">
                    </div>
                </div>
                <div class="col-sm-1"></div>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio38/CESAR-LINEA-001.png">
                </div>
                <p class="text-justify fontMS500 font-24">
                    <br><br>
                    EL CONJUNTO DE TEXTOS DE ESTA SECCIÓN, EN PALABRAS DE MANUEL MIGUEL DE PRIEGO, SON AQUELLOS
                    «EN LOS QUE CONVERGEN LAS CARACTERÍSTICAS DE LAS ESPECIES DEL PERIODISMO DENOMINADAS
                    CRÓNICA Y REPORTAJE (ESTE ÚLTIMO, ABSORBIENDO A LA PRIMERA) CON MARCADO INGREDIENTE DE
                    DIGRESIÓN PROPIA DEL ENSAYO, POR UN LADO, Y, POR EL OTRO, TEXTOS, DECIMOS, DE CONTENIDO
                    FUERTEMENTE POLÉMICO DONDE PREDOMINAN LA VISIÓN Y EL COMPROMISO VALLEJIANO CON EL
                    MARXISMO Y SU APLICACIÓN EN LA ANTIGUA UNIÓN SOVIÉTICA, Y LA ADOPCIÓN, EN OCASIONES
                    MARCADAMENTE DOGMÁTICA, DE LOS PUNTOS DE VISTA DEL LLAMADO SOCIALREALISMO O REALISMO
                    SOCIALISTA».
                    <br><br><br>
                </p>
                <div class="row">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-4"  style="background: #465a65;">
                        <a href="https://hdl.handle.net/20.500.14428/12500" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-031.png">
                        </a>
                        
                    </div>
                    <div class="col-sm-4" style="background: #465a65;">
                        <p class="text-justify text-white fontMS100Italic font-14" style="padding-right: 3%;">
                            <br><br>
                            Rusia en 1931 : reflexiones al pie del
                            Kremlin / César Vallejo. – Madrid: Eds.
                            Ulises, 1931. – 268, xi p. ; 17 cm.<br><br>
                            «El presente libro se dirige, de preferencia,
                            al gran público. Mi propósito es de dar en
                            él una imagen del proceso soviético,
                            interpretada objetiva y racionalmente y
                            desde cierto plano técnico. Trato de
                            exponer los hechos tal como los he visto y
                            comprobado durante mis permanencias en
                            Rusia, y trato también de descubrirles, en
                            lo posible, su perspectiva histórica,
                            iniciando a los lectores en el conocimiento
                            más o menos científico de aquellos,
                            conocimiento científico sin el cual nadie se
                            explica nada claramente. Mi esfuerzo es, a
                            la vez, de ensayo y de vulgarización»
                            (César Vallejo).
                            <br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/12500" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>  
                        </p>
                    </div>
                    <div class="col-sm-2"></div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-1"></div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/63334" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-032.png">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            [Notas y anotaciones textuales de César
                            Vallejo para su obra sobre Rusia,
                            recogidas después de su muerte]. – [París,
                            1929-1930]. – 145 folios ; 27.7 x 21.5 cm.<br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/63334" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/58185" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-033.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Notas sobre “Contra el secreto
                            profesional” halladas en una libreta de
                            1929 / [César Vallejo]. [París, 1929]. 72 f.
                            + 1 carátula : 30 x 21 cm.<br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/58185" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/58184" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-034.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Contra el secreto profesional / César
                            Vallejo. Madrid, 1931. 36 f. + 1
                            carátula : 28 x 21.5 cm.<br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/58184" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-1"></div>
                    <div class="col mx-2 md-2">

                        <a href="https://hdl.handle.net/20.500.14428/63338" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-035.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Notes sur une nouvelle esthétique
                            théatrale / [César Vallejo]. -- [París, dic.
                            1934]. – 17 p. ; 28 x 21.6 cm.<br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/63338" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col mx-2 md-2">
                        <a href="http://hdl.handle.net/20.500.14428/81119" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-036.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            El movimiento dialéctico en un tren /
                            César Vallejo. Mundial : revista semanal
                            ilustrada. Año VIII, no. 460 (12 abr.
                            1929). Pág 4.<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81119" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col mx-2 md-2">
                        <a href="http://hdl.handle.net/20.500.14428/81109" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-037.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Acerca de la Revolución Rusa / César
                            Vallejo. El Comercio (28 abr. 1929).
                            Pág. 19.<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/81109" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio38/CESAR-LINEA-003.png" width="90%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100 font-18">
                            <br>
                            <span>
                                <br><br>
                                «LA CRÓNICA DE VALLEJO ES UN TRABAJO BELLO, METICULOSO, DONDE SE ENCUENTRA, ME PARECE, LA URGENCIA DE LA
                                CRÓNICA RÁPIDA, PERO BIEN HECHA. HAY UNA ESTRUCTURA MUY BIEN LOGRADA, DONDE SE ESCUCHA LA MANO
                                CUIDADOSA DEL POETA, DE ESE SER HUMANO QUE CONOCE SU OFICIO Y QUE, A PESAR DE LA URGENCIA DEL DÍA A DÍA,
                                LOGRA SACAR DE LA VIDA COTIDIANA PÁGINAS DE PROSA POÉTICA. A ESTO ES A LO QUE SE REFIERE ORRILLO CUANDO
                                AFIRMA QUE VALLEJO TRASCIENDE LOS GÉNEROS COMO EL PERIODISMO Y LA LITERATURA, DONDE EL PRIMERO ES LO
                                UTILITARIO Y PRAGMÁTICO Y LO SEGUNDO ES "LO INTEMPORAL, LO PURO, LO NO UTILITARIO"».<br><br>
                                («VALLEJO POETA, VALLEJO PERIODISTA: "DOS ESPÍRITUS" EN EL MISMO ESCRITOR». JOSÉ ALBERTO GATGENS CÉSPEDES. 2011).   
                                <br><br>
                            </span>
                        </p>

                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio38/CESAR-LINEA-004.png" class="reflejo"
                    width="90%" style="margin-left: 10%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row ">
                    
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio38/CESAR-LINEA-001.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 350%;margin-bottom: 25%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            CORRESPONDENCIA<br>

                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio38/CESAR-LINEA-001.png">
                    </div>
                </div>
                
                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio38/CESAR-LINEA-001.png">
                </div>

                <div class="row mt-5">
                    
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/58604" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-038.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            [Carta de] César Vallejo a Leoncio Muñoz R.
                            Lima, 20 de noviembre de 1922. 1 f. 27.5 x 21
                            cm.<br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/58604" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/58618" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-039.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            [Postal de] César Vallejo a Néstor P. Vallejo.
                            Santander, 11 de julio de 1923. 2 f. 9.3 x 14.6
                            cm.<br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/58618" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="https://hdl.handle.net/20.500.14428/58606" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-040.png">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            [Carta al] Dr. Carlos C. Godoy. Lima, 16 de
                            junio de 1923. 2 f. 21.5 x 13.5 cm.<br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/58606" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/80815" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-041.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            [Carta a] Carlos Raygada. París, 15 de
                            setiembre de 1923. 1 f. 20.3 x 13.1 cm.<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/80815" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    
                </div>

                <div class="row mt-5">
                    
                    <div class="col mx-2 md-2">
                        <a href="https://hdl.handle.net/20.500.14428/62981" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-042.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            [Carta de] César Vallejo a Luis Varela
                            Orbegoso. París, 25 de noviembre de
                            1924. 1 f. 17.5 x 10.1 cm.<br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/62981" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-2 md-2">
                        <a href="https://hdl.handle.net/20.500.14428/57952" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-043.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            [Carta de] César Vallejo a Pablo [Abril
                            de Vivero]. París, 8 de febrero de 1926.
                            2 f. 21.6 x 14.1 cm.<br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/57952" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-2 md-2">
                        <a href="https://hdl.handle.net/20.500.14428/58609" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-044.png">
                        </a>
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            [Carta de] César Vallejo a Carlos Godoy.
                            París, 15 de agosto de 1926. 1 f., 1 f. en
                            blanco. 21 x 13.6 cm.<br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/58609" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col mx-2 md-2">
                        <a href="https://hdl.handle.net/20.500.14428/62168" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-044.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            [Carta de] César Vallejo a Luis Varela
                            Orbegoso. París, 25 de setiembre de
                            1928. 2 f., 1 f. en blanco. 20.5 x 13.2 cm.<br><br>
                            Disponible en: <a href="https://hdl.handle.net/20.500.14428/62168" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-6">
                        <img width="100%" src="/assets/images/micrositio/micrositio38/CESAR-LINEA-005.png">
                    </div>
                    <div class="col-sm-6"></div>
                </div>

                <div class="row">
                    <div class="col-sm-6">
                        <br><br>
                        <div class="row" style="color: #000000">
                            <div class="col-sm-2" style="width: 10%">
                                <img src="/assets/images/micrositio/micrositio38/CESAR-ICONO-002.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-14" style="word-wrap: break-word">
                                    [Carta de] César Vallejo a Luis Varela Orbegoso. Moscú, 28 de
                                    octubre de 1928. 1 f. 26.8 x 21 cm.
                                    <br><br>
                                    <span class="fontMS300">
                                    Disponible en:<br>
                                    <a href="https://hdl.handle.net/20.500.14428/62546" target="_blank" style="color: #000000">https://hdl.handle.net/20.500.14428/62546</a>
                                    <br><br>
                                    </span>
                                </p>
                            </div>
                            <div class="col-sm-2" style="width: 10%">
                                <img src="/assets/images/micrositio/micrositio38/CESAR-ICONO-002.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-14" style="word-wrap: break-word">
                                    [Postal de] César Vallejo a Carlos Godoy. Venecia, octubre de
                                    1929. 1 f. 9 x 14.1 cm.
                                    <br><br>
                                    <span class="fontMS300">
                                    Disponible en:<br>
                                    <a href="https://hdl.handle.net/20.500.14428/58622" target="_blank" style="color: #000000">https://hdl.handle.net/20.500.14428/58622</a>
                                    <br><br>
                                    </span>
                                </p>
                            </div>
                            <div class="col-sm-2" style="width: 10%">
                                <img src="/assets/images/micrositio/micrositio38/CESAR-ICONO-002.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-14" style="word-wrap: break-word">
                                    [Postal de] César Vallejo a Aurelio Miró Quesada. Rostof, 21 de
                                    octubre de 1931. 1 f. 10.5 x 15 cm.
                                    <br><br>
                                    <span class="fontMS300">
                                    Disponible en:<br>
                                    <a href="https://hdl.handle.net/20.500.14428/58625" target="_blank" style="color: #000000">https://hdl.handle.net/20.500.14428/58625</a>
                                    <br><br>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <br><br>
                        <div class="row" style="color: #000000">
                            <div class="col-sm-2" style="width: 10%">
                                <img src="/assets/images/micrositio/micrositio38/CESAR-ICONO-002.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-14" style="word-wrap: break-word">
                                    [Carta de] César Vallejo a Aurelio Miró Quesada Sosa. París, 23 de
                                    julio de 1929. 1 f. 21.4 x 13.8 cm.
                                    <br><br>
                                    <span class="fontMS300">
                                    Disponible en:<br>
                                    <a href="https://hdl.handle.net/20.500.14428/57949" target="_blank" style="color: #000000">https://hdl.handle.net/20.500.14428/57949</a>
                                    <br><br>
                                    </span>
                                </p>
                            </div>
                            <div class="col-sm-2" style="width: 10%">
                                <img src="/assets/images/micrositio/micrositio38/CESAR-ICONO-002.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-14" style="word-wrap: break-word">
                                    [Postal de] César Vallejo a Aurelio Miró Quesada. Praga, 25 de
                                    octubre de 1929. 1 f. 9 x 14.2 cm.
                                    <br><br>
                                    <span class="fontMS300">
                                    Disponible en:<br>
                                    <a href="https://hdl.handle.net/20.500.14428/58613" target="_blank" style="color: #000000">https://hdl.handle.net/20.500.14428/58613</a>
                                    <br><br>
                                    </span>
                                </p>
                            </div>
                            <div class="col-sm-2" style="width: 10%">
                                <img src="/assets/images/micrositio/micrositio38/CESAR-ICONO-002.png">
                            </div>
                            <div class="col-sm-10">
                                <p class="fontMS500 font-14" style="word-wrap: break-word">
                                    [Carta de César Vallejo a Aurelio Miró Quesada Sosa]. París, 7 de
                                    diciembre de 1935. 2 f. 28.6 x 15.4 cm.
                                    <br><br>
                                    <span class="fontMS300">
                                    Disponible en:<br>
                                    <a href="https://hdl.handle.net/20.500.14428/57953" target="_blank" style="color: #000000">https://hdl.handle.net/20.500.14428/57953</a>
                                    <br><br>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio38/CESAR-LINEA-003.png" width="90%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100 font-18">
                            <br>
                            <span>
                                <br><br>
                                «ES PRECISO ACLARAR QUE EL EPISTOLARIO GENERAL HA CONTRIBUIDO ENORMEMENTE AL MEJOR CONOCIMIENTO “DE ESE
                                GRAN SER HUMANO QUE VALLEJO FUE, Y MOSTRARLO A VECES EN SUS INSTANTES DE MAYOR DESVALIMIENTO, AYUDARÁ A
                                DAR RELIEVE MÁS FIRME, MÁS SEGURO BULTO AL MONUMENTO DE SU SER ENTERO Y COMPLEJO, AQUEL QUE SIN SER
                                NOTADO APENAS EN SU PARÍS COTIDIANO, FUNDÍA EN SILENCIO SUS DOS MATERIALES RADICALES: EL DE SU AMÉRICA
                                PERUANA Y PRIMERA Y EL DE SU ESPAÑA ABUELA Y NIETA”».<br><br>
                                («EL ROSTRO HUMANO DE VALLEJO A TRAVÉS DE SU CORRESPONDENCIA». JESÚS CABEL. 2002).   
                                <br><br>
                            </span>
                        </p>

                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio38/CESAR-LINEA-004.png" class="reflejo"
                    width="90%" style="margin-left: 10%">
            </div>
        </div>
    </div>
</div>

<div class="fondoMorado">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio34\FERNANDOG-LINEA-004.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4 p-3">
                        <p class="fontMS100 text-white font-24">
                            ¿Qué impresión le dejó su primer
                            acercamiento a la obra de Vallejo? ¿Las
                            posteriores lecturas confirmaron esa
                            impresión?

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-005.png">
                        </p>
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS100 text-white font-24">
                            ¿Qué supone para la tradición
                            literaria hispanoamericana la obra
                            de César Vallejo?

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-005.png">
                        </p>
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS100 text-white font-24">
                            En su calidad de lector, ¿qué poema de
                            Vallejo sería el más emblemático y por
                            qué?

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-005.png">
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center  font-40" style="color:#bb32ac;">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS100 text-left font-24">
                    <br><br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Cabel, J. (2002). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">El rostro humano a través de su
                                correspondencia. En: Correspondencia completa /
                                César Vallejo ; edición, estudio preliminar y notas,
                                Jesús Cabel. Lima: Pontificia Universidad Católica del
                                Perú, p. [ix]-lvii.<br>
                            </span>

                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Granados, P. (2020). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Periodismo y humanidades en
                                César Vallejo. Galáxia. No. 43 (São Paulo), p. 41-53. 
                                <br><br>
                                Disponible en: 
                                <a style="color: #000000;" href="https://doi.org/10.1590/1982-25532020144547" target="_blank">
                                https://doi.org/10.1590/1982-25532020144547</a>
                                <br>
                            </span>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Orrillo, W. (1998). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Álbum república peruana 1900: de 
                                Fernando Garreaud (índice, estudio y notas). Boletín 
                                de la Biblioteca Nacional. p. 211-279 : retrs.<br></span>

                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Silva-Santisteban, R. y Moreano, C. (1999). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">El teatro
                                de César Vallejo. En: Teatro completo I / César Vallejo
                                ; presentación de Salomón Lerner Febres ; edición de
                                Ricardo Silva-Santisteban y Cecilia Moreano. Lima:
                                Pontificia Universidad Católica del Perú, p. xvii-xxix.
                                <br></span>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">González Vigil, R. (2013). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Prólogo. En: César Vallejo:
                                narrativa completa / introducción, edición y notas de
                                Ricardo González Vigil. – Nueva edición, actualizada y
                                aumentada. – Lima: Ediciones Copé, p. 7-51.
                            </span>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Miguel de Priego, M. (2002). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Estudio preliminar:
                                Prólogo. En: Ensayos y reportajes completos / César
                                Vallejo ; edición, estudio preliminar y notas de
                                Manuel Miguel de Priego. Lima: Pontificia Universidad
                                Católica del Perú, p. [ix]-cv.<br>
                            </span>

                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Puccinelli, J. (2002). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Estudio preliminar: César Vallejo
                                a través de sus artículos y crónicas. En: Artículos y
                                crónicas completos I / César Vallejo ; presentación de
                                Salomón Lerner Febres ; recopilación, prólogo, notas
                                y documentación de Jorge Puccinelli. Lima: Pontificia
                                Universidad Católica del Perú, p. [xiii]-xl.
                            </span>

                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Vallejo, C. (2004). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Obras esenciales. Selección,
                                prólogo y cronología de Ricardo-Silva Santisteban.
                                Lima: Pontificia Universidad Católica del Perú.
                            </span>

                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
